import Bowser from "bowser";
import * as AOS from "aos";
import * as scrollnav from "scrollnav/dist/scrollnav.min.umd";

// AOS
AOS.init({
  offset: 100,
  duration: 600,
  easing: "ease-in",
  anchorPlacement: "top-center",
});

jQuery(document).ready(function($) {
  // Inside of this function, $() will work as an alias for jQuery()
  // and other libraries also using $ will not be accessible under this shortcut
  // https://codex.wordpress.org/Function_Reference/wp_enqueue_script#jQuery_noConflict_Wrappers

  // Touch Device Detection
  var isTouchDevice = "ontouchstart" in document.documentElement;
  if (isTouchDevice) {
    $("body").removeClass("no-touch");
    $("body").addClass("touch");
  }

  // Browser detection via Bowser (https://github.com/lancedikson/bowser) - add detection as needed
  const userBrowser = Bowser.getParser(window.navigator.userAgent);
  const browser = userBrowser.getBrowser();

  if (browser.name === "Internet Explorer" && browser.version == "11.0") {
    $("body").addClass("ie-11");
  } else if (browser.name === "Safari") {
    $("body").addClass("safari");
  }

  // Menu functions
  function toggleMenu(icon, menu) {
    $("html").toggleClass("locked");
    $("body").toggleClass("locked masked");

    icon.toggleClass("active");
    menu.slideToggle();

    icon.attr("aria-expanded", icon.hasClass('active') ? "true" : "false");
  }

  function closeMenu(icon, menu) {
    if( menu.css("display") == "block" ) {
      $("html").removeClass("locked");
      $("body").removeClass("locked masked");
    }

    icon.removeClass("active");
    menu.slideUp();

    icon.attr("aria-expanded", "false");
  }

  // Main menu function
  $(".menu-icon").on("click", function() {
    toggleMenu($(this), $(".nav--mobile"));
  });

  // Close menu on desktop
  $(window).on("resize", function() {
    if( $(window).width() > 1023 ) {
      closeMenu($(".menu-icon"), $(".nav--mobile"));
    }
  });

  // Close menu on outside click
  $(document).on("click", function(e) {
    if( !$(e.target).closest(".site-header").length ) {
      closeMenu($(".menu-icon"), $(".nav--mobile"));
    }
  });

  // Close menu on ESC key 
  $(document).on("keyup", function(e) {
    if( e.which == 27) {
      closeMenu($(".menu-icon"), $(".nav--mobile"));
    }
  });

  // Mobile menu sub-menu toggle
  $(".nav--mobile .menu-item-has-children > a").on("click", function(e) {
    e.preventDefault();

    $(this).siblings(".sub-menu").slideToggle();
    $(this).toggleClass("active");
  });

  // Tabbed table section 
  $(".tabbed-table__tab").on("click", function() {
    let id = $(this).attr("id");

    // Remove active class from other tabs 
    $(this).siblings(".tabbed-table__tab").removeClass("active");
    $(this).parents(".tabbed-table").find(".tabbed-table__content > div").removeClass("active");

    // Add active class to this tab
    $(this).addClass("active");
    $(".tabbed-table__content > div#content-" + id).addClass("active");
  });

  // Sample content nav
  if( $(".sample-content").length ) {
    let content = document.querySelector(".sample-content .column.is-9"),
      insertTarget = document.querySelector(".sample-content__nav");

    scrollnav.init(content, {
      sections: ".sample-content__section .anchor",
      insertTarget: insertTarget,
    });
  }

  // Recalculate AOS positions after a successful Fluent Forms submission.
  $(document).on("fluentform_submission_success", function () {
    setTimeout(function () {
      AOS.refreshHard();
    }, 300);
  });

  // // Accordions section 
  // $(".accordion__header").on("click", function() {
  //   // Close other accordions
  //   $(this).parents(".accordions-section").find(".accordion__header").not(this).find("i").removeClass("fa-minus").addClass("fa-plus");
  //   $(this).parents(".accordions-section").find(".accordion__header").not(this).siblings(".accordion__content").slideUp();

  //   // Toggle this one
  //   if( $(this).find("i").hasClass("fa-plus") ) {
  //     $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
  //   } else {
  //     $(this).find("i").removeClass("fa-minus").addClass("fa-plus");
  //   }
    
  //   $(this).siblings(".accordion__content").slideToggle();
  // });

  // Load more - main ajax function 
  function loadPosts(cat, tag, paged, total) {
    // Show loading animation
    $(".post-list-section .loading-animation").show();

    // Look for/load new posts
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      dataType: "json",
      data: {
        action: "f1_advanced_search",
        cat: cat,
        tag: tag,
        paged: paged,
      },
      success: function (res) {
        if (res.html != null) {
          $(".post-list-section__list").append(res.html);
        } else {
          $(".post-list-section__list").html("<p>No more posts have been found.</p>");
        }
      },
      complete: function () {
        // Update page of next load
        paged++; 
        $(".post-list-section__list").attr("data-page", paged);

        // Hide loading animation
        $(".post-list-section .loading-animation").hide();

        // If we've loaded all posts, hide load button and show message
        if( paged > total ) {
          $(".post-list-section #load-more").hide();

          $(".post-list-section__load").html("<p>All posts have been loaded.</p>");
        }
      }
    });
  }

  // Load more - click 
  $("#load-more").on("click", function() {
    let list = $(this).parents(".post-list-section").find(".post-list-section__list"),
      cat = list.attr("data-cat") ? list.attr("data-cat") : null,
      tag = list.attr("data-tag") ? list.attr("data-tag") : null,
      paged = list.attr("data-page") ? list.attr("data-page") : 2,
      total = list.attr("data-total-pages");

    loadPosts(cat, tag, paged, total); 
  });

  // Smooth anchor link scrolling 
  $("a[href*=\\#]").on("click", function (e) {
    let slug = this.href.split("#")[1].replace("#", "");

    // Only if no matching modal
    if( !$(".modal#modal-" + slug).length && $(".anchor#" + slug).length ) {
      e.preventDefault();
      if(this.pathname === window.location.pathname) {
        // Store hash
        let hash = this.hash;
  
        $("html, body").animate({
          scrollTop: $(hash).offset().top,
        }, 800, function(){
  
          window.location.hash = hash;
        });
      }
    }
  });
});
